import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from 'utils/services';

import {
  ChangeReportsStatusReqProps,
  ChangeReportsStatusResProps,
  GetReportDetailsResProps,
  GetReportReqProps,
  GetReportResProps,
  GetReportsReqProps,
  GetReportsResProps
} from './reports.types';

export const reportsApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    changeReportsStatus: build.mutation<ChangeReportsStatusResProps, ChangeReportsStatusReqProps>({
      query: (body) => ({
        body,
        method: 'POST',
        url: '/reports/change-status'
      })
    }),
    getReport: build.query<GetReportResProps, GetReportReqProps>({
      query: (params) => ({
        params,
        responseHandler: (response: Response) => response.blob().then((res) => res),
        url: '/reports/details'
      })
    }),
    getReportResults: build.query<GetReportDetailsResProps, GetReportReqProps>({
      query: ({ reportId }) => ({
        url: `/reports/${reportId}/results`
      })
    }),
    getReports: build.query<GetReportsResProps, GetReportsReqProps>({
      query: () => '/reports'
    })
  }),
  reducerPath: 'reportsApi',
  tagTypes: ['Reports']
});

export const {
  useChangeReportsStatusMutation,
  useGetReportsQuery,
  useLazyGetReportQuery,
  // useGetReportResultsQuery,
  useLazyGetReportResultsQuery
} = reportsApi;
